import * as React from "react";
import { Box } from '@material-ui/core';


const SanitizedBoxInToolbar = ({basePath, handleSubmit, handleSubmitWithRedirect, onSave, submitOnEnter, ...props}) => (
    <Box {...props}/>
)

export default SanitizedBoxInToolbar